import { JsonFormat, stringJsonFormat } from "@redotech/json/format";
import { TriggerType } from "./trigger-enums";

export const triggerTypeJsonFormat: JsonFormat<TriggerType> =
  stringJsonFormat as JsonFormat<TriggerType>;
